import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import QRCode from "qrcode";
import {toast} from "react-toastify";
import { SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {useTranslation} from "react-i18next";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import CustomChip from "../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../enums/statusEnum";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import routes from "../../../../Routes/routes";
import {
    DetailsIconsOptions,
    NextIconsOptions,
    PersonOutlinedChip,
    QrCodeIcon
} from "../../../../components/buttons/IconButtons";
import TableFunction from "../../../../components/table/TableFunction";
import {DATE_TIME_FORMAT_NAME_MODEL, errorMsg, getDateFormat} from "../../../../Apis/functions";
import {GetMaterialRequestQrCode} from "../../../../reduxToolkit/MaterialRequest/MaterialRequestApi";
import {
    SEARCH_MODEL
} from "../../../../components/table/Model/TableModel";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import {useNavigate} from "react-router-dom";
import CustomImageTable from "../../../../components/CustomImageTable";
import {USER_TYPE_NAME_MODEL} from "../../../../enums/userTypeEnum";


/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const MaterialRequestTableApp = ({
    selectedList,
    setSelectedList,
    setIsAllChecked,
    option,
    setBodyForExport,
    searchElement,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [modified, setModified] = useState(false);
    const { t } = useTranslation();
    const { permission, user } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const isGuard = user?.data?.userType?.name === USER_TYPE_NAME_MODEL.GUARD;
    const tableId = "tbl_mrt_material_requests";
    const searchId = "txt_mrt_search_material_requests";
    const [results, setResults] = useState(null);
    const deletePermission = false;
    const leftPosition = 0;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head" customWidth="155">{t('folio')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_by')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('date')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('approval_status')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('dispatch_status')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if(!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item) => {
            const dispatchStatusId = item?.dispatchStatusId;
            const approvalStatusId = item?.approvalStatusId;
            return (
                [
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"} tooltip={item?.code}>
                        <span className={"text-ellipsis"}>{item?.code}</span>
                    </CustomTd>,
                    <CustomTd tableId={tableId} >{item?.title}</CustomTd>,
                    <CustomTd tableId={tableId} >
                        <CustomImageTable
                            tooltip={t(item?.requestedBy)}
                            containerClass={"d-flex"}
                            icon={<div className={`mr-2 d-flex`}><PersonOutlinedChip/></div>}
                        >
                            {t(item?.requestedBy)}
                        </CustomImageTable>
                    </CustomTd>,
                    <CustomTd tableId={tableId} >
                        {getDateFormat(item?.createdAt, null, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                    </CustomTd>,
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[approvalStatusId]}
                            fontColor={statusFontColor[approvalStatusId]}
                            borderColor={statusBorderColor[approvalStatusId]}
                            legend={t(status[approvalStatusId])}
                            variant={'large'}
                        />
                    </CustomTd>,
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[dispatchStatusId]}
                            fontColor={statusFontColor[dispatchStatusId]}
                            borderColor={statusBorderColor[dispatchStatusId]}
                            legend={t(status[dispatchStatusId])}
                            variant={'large'}
                        />
                    </CustomTd>
                ]
            );
        });

        return {
            body: body,
            data: results?.content
        }
    };

    const getActionsButtons = (item, index) => {
        return <>

                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`}
                >
                    { !isGuard ?
                        [
                            <DropDownMenuItem
                                id={'btn_mrt_approval-tracker' + item.id}
                                index={index}
                                name={t('approval_tracker')}
                                url={routes.materialRequest.approvalTracker + item?.id}
                                icon={<NextIconsOptions />}
                            />,
                            <DropDownMenuItem
                                id={`dmt_mrt_details_${item.id}`}
                                index={index}
                                handleClose={handleClose}
                                name={t('details')}
                                icon={<DetailsIconsOptions />}
                                url={routes.materialRequest.details + item?.id}
                            />
                        ]
                        :

                        [ item?.dispatchStatusId === STATUS_MODEL.PENDING_TO_APPROVE ?
                            <DropDownMenuItem
                                id={`dmt_mrt_details_${item.id}`}
                                index={index}
                                handleClose={handleClose}
                                name={t('details')}
                                icon={<DetailsIconsOptions />}
                                url={routes.materialRequest.details + item?.id}
                            />
                            :
                            <DropDownMenuItem
                                id={`dmt_mrt_dispatch_${item.id}`}
                                index={index}
                                handleClose={handleClose}
                                name={t('material_dispatch')}
                                icon={<DetailsIconsOptions />}
                                url={routes.materialRequest.dispatch + item?.id}
                            />
                        ]

                    }
                    { !isGuard &&
                      item?.approvalStatusId === STATUS_MODEL.APPROVED &&
                      item?.dispatchStatusId === STATUS_MODEL.PENDING_TO_DISPATCH &&
                        <DropDownMenuItem
                            id={`dmt_mrt_qr_${item.id}`}
                            index={index}
                            handleClose={handleClose}
                            name={t('qr_code')}
                            icon={<QrCodeIcon />}
                            click={() => getQrCode(item)}
                        />
                    }
                </DropDownMenuProfile>

        </>;
    }

    /**
     * Retrieves the QR code of an approved material request
     * and downloads it as a PNG file.
     *
     * @async
     * @param {Object} item - Material request row information.
     *
     * @returns {void}
     */
    const getQrCode = async (item) => {
        const { payload } = await dispatch(GetMaterialRequestQrCode(item?.id));
        const { data, success, code } = payload.data;

        if (!success) {
            errorMsg(code);
            return;
        }

        try {
            const image = await QRCode.toDataURL(JSON.stringify(data), { width: 300 });
            const link = document.createElement('a');
            link.href = image;
            link.download = `${t('qr_code')}_${item?.code}.png`;
            link.click();
        } catch (err) {
            toast.error(t('something_went_wrong_2'));
        }
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            view: VIEW_TYPE.LIST.viewType,
        });

        setBodyForExport(body);

        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }


    const {
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data:results,
        getThead,
        getTbody,
        labelRowsPerPage:'requests_per_page',
        fixedPagination: true,
        hasContainer:false,
        setIsAllChecked,
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        navigate,
        handleDeleteAll,
        permission,
        DEV,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        rowsPerPage,
        setResults,
        deletePermission
    }
};
